"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSonarObjectsOptimisticChange = exports.addSonarObjectsOptimisticChange = void 0;
const add_1 = require("./add.js");
const remove_1 = require("./remove.js");
exports.addSonarObjectsOptimisticChange = add_1.coreSonarObjectsOptimisticChangeAddSlice.syncActionCreator;
exports.removeSonarObjectsOptimisticChange = remove_1.coreSonarObjectsOptimisticChangeRemoveSlice.syncActionCreator;
//# sourceMappingURL=actions.js.map